import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    props: {},
    computed: {
        ...mapState('categoriesModule', [
            'menuCategories'
        ]),
    },
});
